module.exports = __webpack_public_path__ + "assets/img/INTERIOR10.45b376c9.png";